import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { length } from 'ramda';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { isPresent, isBlank } from 'utils/helperMethods';

import { Skeleton } from '@material-ui/lab';
import Loader from 'sharedComponents/Loader';

import InfiniteScroll from 'react-infinite-scroll-component';
import useLoanOfficers from 'reducers/hooks/public/buyer/useLoanOfficers';
import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const PER_PAGE = 10;

const LoanOfficersList = props => {
  const { stateCode, onLoanOfficerSelect } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    loadLoanOfficers,
    loanOfficers,
    meta,
    loadMoreLoanOfficers,
    isLoanOfficersLoading,
    isLoanOfficersIdle,
  } = useLoanOfficers();

  const buildSearchParams = () => {
    return { q: { licensedInStateByStateCodeQ: stateCode }, perPage: PER_PAGE };
  };

  useEffect(() => {
    const params = buildSearchParams();
    loadLoanOfficers(params);
  }, [stateCode]);

  const { nextPage } = meta;
  const hasMore = isPresent(nextPage);

  const handleLoadMore = () => {
    const params = buildSearchParams();
    loadMoreLoanOfficers({ page: nextPage, ...params });
  };

  if (isLoanOfficersLoading || isLoanOfficersIdle) {
    return (
      <div className={classes.loader}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.BuyerLoanOfficerSearchSurvey.LoanOfficerSelect.LoanOfficersList.emptyLoanOfficers')}
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.container} id="scrollableDiv" key="scrollableDiv">
      <InfiniteScroll
        dataLength={length(loanOfficers)}
        next={handleLoadMore}
        hasMore={hasMore}
        loader={
          <div>
            {[1, 2].map(key => (
              <div key={key} className={classes.skeletonBox}>
                <Skeleton variant="circle" animation="wave" width={40} height={40} />
                <Skeleton variant="rect" animation="wave" className={classes.skeletonText} />
              </div>
            ))}
          </div>
        }
        scrollableTarget="scrollableDiv"
      >
        {loanOfficers.map(loanOfficer => (
          <LoanOfficerCard key={loanOfficer.id} loanOfficer={loanOfficer} onSelect={onLoanOfficerSelect} />
        ))}
      </InfiniteScroll>
    </div>
  );
};

LoanOfficersList.propTypes = {
  stateCode: PropTypes.string.isRequired,
  onLoanOfficerSelect: PropTypes.func.isRequired,
};

export default LoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/BuyerLoanOfficerSearchSurvey/components/LoanOfficerSelect/components/LoanOfficersList/LoanOfficersList.js